import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseTypeFlag } from 'src/app/models/case/case.interface';
import { PaginatedData, PaginatedDataResponse } from 'src/app/models/common/common.interface';
import { CaseService } from 'src/app/services/case.service';
import { LimosService } from 'src/app/services/limos.service';

@Component({
  selector: 'app-case-detail',
  templateUrl: './case-detail.component.html',
  styleUrls: ['./case-detail.component.css'],
})
export class CaseDetailComponent implements OnInit {
  @Output() formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();
  private unsubscribe$ = new Subject<void>();
  caseData$: Observable<any>;
  hearingDataForm: FormGroup;
  caseTypeFlags$: Observable<CaseTypeFlag[]>;

  constructor(
    private caseService: CaseService,
    protected formBuilder: FormBuilder,
    private limosService: LimosService
  ) {}

  ngOnInit() {
    this.caseData$ = this.caseService.getCaseData();
    this.initForm();
    this.caseTypeFlags$ = this.caseTypeFlags();
  }

  initForm() {
    this.hearingDataForm = this.formBuilder.group({
      hearing_date: [''],
      hearing_time: ['', [this.limosService.timeFormatValidator]],
      hearing_venue: [''],
      judge: [''],
      outcome: [''],
      case: [],
    });
  }

  onSubmitForm() {
    this.formSubmitted.emit(true);
  }

  saveLimosHearingData() {}

  caseTypeFlags = () : Observable<CaseTypeFlag[]> => {
    return this.caseService
      .getCaseTypeFlags(
        10,
        1,
        this.caseService.caseDataValue?.clientInformation?.case_type?.id
      )
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<CaseTypeFlag>>) =>
            res?.details?.hits || []
        )
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
